//Button Groups
export const BUTTON_GROUP = ["secondary", "success", "info", "warning", "danger", "light", "dark"];

//Radio button group
export const RADIO_BUTTON_GROUP = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " for active state and",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: "disabled='disabled'",
  },
  {
    text: " attribute",
  },
];

export const RADIO_BUTTON_LIST = [
  {
    idOne: 3,
    idTwo: 4,
    color: "secondary",
    name: "radio-2",
  },
  {
    idOne: 5,
    idTwo: 6,
    color: "success",
    name: "radio-3",
  },
  {
    idOne: 7,
    idTwo: 8,
    color: "info",
    name: "radio-4",
  },
  {
    idOne: 9,
    idTwo: 10,
    color: "warning",
    name: "radio-5",
  },
  {
    idOne: 11,
    idTwo: 12,
    color: "danger",
    name: "radio-6",
  },
  {
    idOne: 13,
    idTwo: 14,
    color: "light",
    name: "radio-7",
  },
];

//Check Box Button Groups
export const CHECKBOX_BUTTON_GROUP = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " for active state and",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: "disabled='disabled'",
  },
  {
    text: " attribute",
  },
];

export const CHECKBOX_BUTTON_LIST = [
  {
    idOne: 3,
    idTwo: 4,
    color: "secondary",
  },
  {
    idOne: 5,
    idTwo: 6,
    color: "success",
  },
  {
    idOne: 7,
    idTwo: 8,
    color: "info",
  },
  {
    idOne: 9,
    idTwo: 10,
    color: "warning",
  },
  {
    idOne: 11,
    idTwo: 12,
    color: "danger",
  },
  {
    idOne: 13,
    idTwo: 14,
    color: "light",
  },
];

//Nesting
export const NESTING = [
  {
    text: "Make nesting buttons",
  },
];

export const NESTING_LIST=["md","lg"]

//Vertical Group Button
export const VERTICAL_BUTTON_GROUP = [
  {
    text: "Make vertical buttons",
  },
];